/**
 * @file constants.js
 * @author fuqiang15
 */
import region from './region';

export default {
    conditionalNameDatasource: [
        {
            'l': '落地页名称',
            'v': 'name'
        },
        {
            'l': '广告主名称',
            'v': 'aderName'
        },
        {
            'l': '落地页ID',
            'v': 'id'
        }
    ],
    APP_SERVICE_TYPE: [
        {l: '地图服务（废弃）', v: 'MAP'},
        {l: '地图服务（新）', v: 'MAP2'},
        {l: '投票服务', v: 'VOTE'},
        {l: '微博服务', v: 'WEIBO'},
        {l: '领券服务', v: 'LOTTERY'},
        {l: '表单服务', v: 'SCHEMA'},
        {l: 'AR服务', v: 'AR'},
        {l: '语音合成服务', v: 'AUDIO'},
        {l: '自定义服务', v: 'CUSTOM'}
    ],
    APP_SERVICE_MAP_FIELD_TYPE: [
        {l: 'Int64', v: '1'},
        {l: 'double', v: '2'},
        {l: 'string', v: '3'},
        {l: '在线图片URL', v: '4'}
    ],
    API_PROTOCOL: [
        {alias: 'HTTP', l: 'HTTP', v: 0},
        {alias: 'HTTPS', l: 'HTTPS', v: 1}
    ],
    API_REQUEST_METHOD: [
        {alias: 'GET', l: 'GET', v: 0},
        {alias: 'POST', l: 'POST', v: 1}
    ],
    API_ENCODING: [
        {alias: 'UTF-8', l: 'UTF-8', v: 0},
        {alias: 'GBK', l: 'GBK', v: 1}
    ],
    API_CONTENT_TYPE: [
        {alias: 'formData', l: 'multipart/form-data', v: 1},
        {alias: 'urlEncoded', l: 'application/x-www-form-urlencoded', v: 2},
        {alias: 'json', l: 'application/json', v: 3},
        {alias: 'xml', l: 'text/xml', v: 4}
    ],
    API_AUTH_TYPE: [
        {alias: 'NoAuth', l: 'No Auth', v: 0},
        {alias: 'BasicAuth', l: 'Basic Auth', v: 1},
        {alias: 'OAuth', l: 'OAuth', v: 2},
        {alias: 'OAuth2.0', l: 'OAuth 2.0', v: 3},
        {alias: 'INNER_TOKEN', l: 'OpenApi Inner Token', v: 4}
    ],
    API_SIGN_TYPE: [
        {alias: 'NoSign', l: 'No Sign', v: 0},
        {alias: 'MD5', l: 'MD5', v: 1},
        {alias: 'RSA', l: 'RSA', v: 2}
    ],
    HTTP_LOCATION: [
        {l: 'URL', v: 'url'},
        {l: 'Header', v: 'header'},
        {l: 'Body', v: 'body'}
    ],
    YES_AND_NO: [
        {l: '是', v: '1'},
        {l: '否', v: '0'}
    ],
    TRUE_AND_FALSE: [
        {l: '是', v: true},
        {l: '否', v: false}
    ],
    APP_SERVICE_STATUS: [
        {l: '草稿', v: 'DRAFT'},
        {l: '审核中', v: 'REVIEWING'},
        {l: '审核未通过', v: 'REJECT'},
        {l: '已发布', v: 'PUBLISHED'},
        {l: '已上线', v: 'ONLINE'},
        {l: '已下线', v: 'OFFLINE'}
    ],
    USER_QUALIFICATION_STATUS: [
        {v: 'EDITING', l: '草稿'},
        {v: 'REVIEWING', l: '审核中'},
        {v: 'REVIEW_FAILED', l: '未通过'},
        {v: 'REVIEW_PASSED', l: '已通过'},
        {v: 'UPDATED', l: '已更新'}
    ],
    USER_STATUS: [
        {v: 'ACTIVE', l: '已启用'},
        {v: 'INACTIVE', l: '已停用'}
    ],
    USER_QUALIFICATION_TYPE: [
        {v: '0', l: '企业'},
        {v: '1', l: '其他'}
    ],
    LAN: [
        {
            v: 'MANDARIN',
            l: '中文普通话'
        },
        {
            v: 'US_ENGLISH',
            l: '美式英语'
        },
        {
            v: 'BRITISH_ENGLISH',
            l: '英式英语'
        }
    ],
    TIMBRE: [
        {
            v: 'MAN',
            l: '标准男声'
        },
        {
            v: 'WOMAN',
            l: '标准女声'
        },
        {
            v: 'EMOTIONAL_MAN',
            l: '情感男声'
        },
        {
            v: 'GIRL',
            l: '童声女声'
        }
    ],
    PAGE_TYPE: [
        {v: 'create', l: '新建'},
        {v: 'edit', l: '编辑'},
        {v: 'detail', l: '查看'},
        {v: 'copy', l: '复制'},
        {v: 'review', l: '审核'}
    ],
    ADDRESS: region,
    INDUSTRIES: [
        {
            name: '美食',
            children: [
                {
                    name: '中餐厅'
                },
                {
                    name: '外国餐厅'
                },
                {
                    name: '小吃快餐店'
                },
                {
                    name: '蛋糕甜品店'
                },
                {
                    name: '咖啡厅'
                },
                {
                    name: '茶座'
                },
                {
                    name: '酒吧'
                }
            ]
        },
        {
            name: '酒店',
            children: [
                {
                    name: '星级酒店'
                },
                {
                    name: '快捷酒店'
                },
                {
                    name: '公寓式酒店'
                }
            ]
        },
        {
            name: '购物',
            children: [
                {
                    name: '购物中心'
                },
                {
                    name: '超市'
                },
                {
                    name: '便利店'
                },
                {
                    name: '家居建材'
                },
                {
                    name: '家电数码'
                },
                {
                    name: '商铺'
                },
                {
                    name: '集市'
                }
            ]
        },
        {
            name: '生活服务',
            children: [
                {
                    name: '通讯营业厅'
                },
                {
                    name: '邮局'
                },
                {
                    name: '物流公司'
                },
                {
                    name: '售票处'
                },
                {
                    name: '洗衣店'
                },
                {
                    name: '图文快印店'
                },
                {
                    name: '照相馆'
                },
                {
                    name: '房产中介机构'
                },
                {
                    name: '公用事业'
                },
                {
                    name: '维修点'
                },
                {
                    name: '家政服务'
                },
                {
                    name: '殡葬服务'
                },
                {
                    name: '彩票销售点'
                },
                {
                    name: '宠物服务'
                },
                {
                    name: '报刊亭'
                },
                {
                    name: '公共厕所'
                }
            ]
        },
        {
            name: '丽人',
            children: [
                {
                    name: '美容'
                },
                {
                    name: '美发'
                },
                {
                    name: '美甲'
                },
                {
                    name: '美体'
                }
            ]
        },
        {
            name: '旅游景点',
            children: [
                {
                    name: '公园'
                },
                {
                    name: '动物园'
                },
                {
                    name: '植物园'
                },
                {
                    name: '游乐园'
                },
                {
                    name: '博物馆'
                },
                {
                    name: '水族馆'
                },
                {
                    name: '海滨浴场'
                },
                {
                    name: '文物古迹'
                },
                {
                    name: '教堂'
                },
                {
                    name: '风景区'
                }
            ]
        },
        {
            name: '休闲娱乐',
            children: [
                {
                    name: '度假村'
                },
                {
                    name: '农家院'
                },
                {
                    name: '电影院'
                },
                {
                    name: 'KTV'
                },
                {
                    name: '剧院'
                },
                {
                    name: '歌舞厅'
                },
                {
                    name: '网吧'
                },
                {
                    name: '游戏场所'
                },
                {
                    name: '洗浴按摩'
                },
                {
                    name: '休闲广场'
                }
            ]
        },
        {
            name: '运动健身',
            children: [
                {
                    name: '体育场馆'
                },
                {
                    name: '极限运动场所'
                },
                {
                    name: '健身中心'
                }
            ]
        },
        {
            name: '教育培训',
            children: [
                {
                    name: '高等院校'
                },
                {
                    name: '中学'
                },
                {
                    name: '小学'
                },
                {
                    name: '幼儿园'
                },
                {
                    name: '成人教育'
                },
                {
                    name: '亲子教育'
                },
                {
                    name: '特殊教育学校'
                },
                {
                    name: '留学中介机构'
                },
                {
                    name: '科研机构'
                },
                {
                    name: '培训机构'
                },
                {
                    name: '图书馆'
                },
                {
                    name: '科技馆'
                }
            ]
        },
        {
            name: '文化传媒',
            children: [
                {
                    name: '新闻出版'
                },
                {
                    name: '广播电视'
                },
                {
                    name: '艺术团体'
                },
                {
                    name: '美术馆'
                },
                {
                    name: '展览馆'
                },
                {
                    name: '文化宫'
                }
            ]
        },
        {
            name: '医疗',
            children: [
                {
                    name: '综合医院'
                },
                {
                    name: '专科医院'
                },
                {
                    name: '诊所'
                },
                {
                    name: '药店'
                },
                {
                    name: '体检机构'
                },
                {
                    name: '疗养院'
                },
                {
                    name: '急救中心'
                },
                {
                    name: '疾控中心'
                }
            ]
        },
        {
            name: '汽车服务',
            children: [
                {
                    name: '汽车销售'
                },
                {
                    name: '汽车维修'
                },
                {
                    name: '汽车美容'
                },
                {
                    name: '汽车配件'
                },
                {
                    name: '汽车租赁'
                },
                {
                    name: '汽车检测场'
                }
            ]
        },
        {
            name: '交通设施',
            children: [
                {
                    name: '飞机场'
                },
                {
                    name: '火车站'
                },
                {
                    name: '地铁站'
                },
                {
                    name: '长途汽车站'
                },
                {
                    name: '公交车站'
                },
                {
                    name: '港口'
                },
                {
                    name: '停车场'
                },
                {
                    name: '加油加气站'
                },
                {
                    name: '服务区'
                },
                {
                    name: '收费站'
                },
                {
                    name: '桥'
                }
            ]
        },
        {
            name: '金融',
            children: [
                {
                    name: '银行'
                },
                {
                    name: 'ATM'
                },
                {
                    name: '信用社'
                },
                {
                    name: '投资理财'
                },
                {
                    name: '典当行'
                }
            ]
        },
        {
            name: '房地产',
            children: [
                {
                    name: '写字楼'
                },
                {
                    name: '住宅区'
                },
                {
                    name: '宿舍'
                }
            ]
        },
        {
            name: '公司企业',
            children: [
                {
                    name: '公司'
                },
                {
                    name: '园区'
                },
                {
                    name: '农林园艺'
                },
                {
                    name: '厂矿'
                }
            ]
        },
        {
            name: '政府机构',
            children: [
                {
                    name: '中央机构'
                },
                {
                    name: '各级政府'
                },
                {
                    name: '行政单位'
                },
                {
                    name: '公检法机构'
                },
                {
                    name: '涉外机构'
                },
                {
                    name: '党派团体'
                },
                {
                    name: '福利机构'
                },
                {
                    name: '政治教育机构'
                }
            ]
        }
    ],
    REVIEW_OPERATION: [
        {v: 'PASSED', l: '通过'},
        {v: 'FAILED', l: '拒绝'}
    ],
    USER_TYPE: [
        {v: 'INSIDE', l: '内部用户'},
        {v: 'OUTSIDE', l: '外部用户'}
    ],
    MATERIAL_TYPE: [
        {v: 'card', l: '卡片'},
        {v: 'frame', l: '中间页'},
        {v: 'component', l: '组件'}
    ],
    CARD_STATUS: [
        {v: 'DRAFT', l: '草稿'},
        {v: 'DESIGN_REVIEWING', l: '设计审核中'},
        {v: 'DESIGN_REVIEW_FAILED', l: '设计审核失败'},
        {v: 'DESIGN_REVIEW_PASSED', l: '设计审核成功'},
        {v: 'WAIT_FOR_LAUNCH', l: '待投放'},
        {v: 'PRODUCT_REVIEWING', l: '物料审核中'},
        {v: 'PRODUCT_REVIEW_FAILED', l: '物料审核失败'},
        {v: 'PRODUCT_REVIEW_PASSED', l: '物料审核成功'},
        {v: 'ONLINE', l: '已上线'},
        {v: 'OFFLINE', l: '已下线'}
    ],
    CARD_FILTERS: [
        {v: 'aderName', l: '广告主名称'},
        {v: 'aderId', l: '广告主ID'},
        {v: 'notes', l: '备注'}
    ],
    FRAME_STATUS: [
        {v: 'DEVELOPING', l: '草稿'},
        {v: 'PUBLISHED', l: '已发布'},
        {v: 'BINDED', l: '已绑定'}
    ],
    TEMPLATE_STATUS: [
        {l: '草稿', v: 'TEMPLATE_DRAFT'},
        {l: '已发布', v: 'TEMPLATE_PUBLISHED'},
        {l: '已禁用', v: 'TEMPLATE_DISABLED'}
    ],
    CARD_TYPE: [
        {v: 'CARD', l: '卡片'},
        {v: 'COMPONENT', l: '组件'}
    ],
    MATERIAL_SEARCH_KEY: [
        {v: 'name', l: '物料名称'},
        {v: 'id', l: 'ID'},
        {v: 'aderName', l: '客户锦囊名'},
        {v: 'userName', l: '服务商名称'}
    ],
    ENTRY_URL: [
        {
            v: 'report',
            l: '/report/index.html'
        },
        {
            v: 'client',
            l: '/client/index.html'
        },
        {
            v: 'admin',
            l: '/admin/index.html'
        },
        {
            v: 'agreement',
            l: '/agreement/index.html'
        },
        {
            v: 'market',
            l: '/market/index.html'
        },
        {
            v: 'areditor',
            l: '/areditor/index.html'
        }
    ],
    AR_RESOURCE_TYPE: [
        {v: 'IMAGE_TYPE', l: 'veui-uploader'},
        {v: 'MUSIC_TYPE', l: 'veui-uploader'},
        {v: 'VIDEO_TYPE', l: 'veui-uploader'},
        {v: 'JPEG_IMAGE_TYPE', l: 'veui-uploader'},
        {v: 'PNG_IMAGE_TYPE', l: 'veui-uploader'},
        {v: 'GIF_IMAGE_TYPE', l: 'veui-uploader'},
        {v: 'MODEL_TYPE', l: 'veui-uploader'},
        {v: 'NORMAL_MODEL_TYPE', l: 'veui-ploader'},
        {v: 'RESOURCE_TYPE', l: 'veui-uploader'},
        {v: 'UDT_RESOURCE_TYPE', l: 'veui-uploader'},
        {v: 'LUA_TYPE', l: 'veui-uploader'},
        {v: 'TXT_TYPE', l: 'veui-uploader'},
        {v: 'WORD_TYPE', l: 'veui-uploader'},
        {v: 'NUMBER_TYPE', l: 'veui-textarea'},
        {v: 'TEXT_TYPE', l: 'veui-textarea'},
        {v: 'TEXTAREA_TYPE', l: 'veui-textarea'}
    ],
    AR_RESOURCE_SUFFIX: [
        {v: 'IMAGE_TYPE', l: '.gif,.jpeg,.jpg,.png,.svg'},
        {v: 'MUSIC_TYPE', l: '.mp3'},
        {v: 'VIDEO_TYPE', l: '.mp4'},
        {v: 'JPEG_IMAGE_TYPE', l: '.jpeg,.jpg'},
        {v: 'PNG_IMAGE_TYPE', l: '.png'},
        {v: 'GIF_IMAGE_TYPE', l: '.gif'}
    ],
    DOMAIN_STATUS_MAP: [
        {v: 'BAIDU', l: '百度域开放'},
        {v: 'NORMAL', l: '百度域关闭'}
    ]
};
